import React from 'react'
import SettingsTagsForm from '../components/setting/settingsTagsForm'

const SettingsTags = () => {
    return (
        <>
            <SettingsTagsForm />
        </>
    )
}

export default SettingsTags